<template>

  <!-- Group Chat -->
  <div
    class="group-chat">

    <beautiful-chat
      is-open
      show-file
      @edit="send"
      show-edition
      show-deletion
      :open="() => {}"
      @remove="remove"
      :close="() => {}"
      :show-emoji="false"
      deletion-confirmation
      always-scroll-to-bottom
      :message-list="messages"
      :on-message-was-sent="send"
      :participants="participants"
      placeholder="Enter your message"
      :show-received-edition="isModerator"
      :show-received-deletion="isModerator"/>

  </div>

</template>

<script>

  import {mapGetters, mapActions} from 'vuex';

  export default {
    name: 'group-chat',
    props: {
      groupId: {
        type: String,
        required: true,
      },
    },
    computed: {
      ...mapGetters('messenger', {
        usersOf: 'chatUsersOf',
        messagesOf: 'chatMessagesOf',
        isModeratorOf: 'isModeratorOf',
      }),
      isModerator() {

        return this.isModeratorOf(
          this.groupId,
        );
      },
      targetId() {

        return `group-${this.groupId}`;
      },
      messages() {

        const messages = this.messagesOf(
          this.targetId,
        );

        return messages;
      },
      participants() {

        return this.usersOf(
          this.targetId,
        );
      },
    },
    methods: {
      ...mapActions('messenger', {
        sendMessage: 'SEND_CHAT_MESSAGE',
        removeMessage: 'REMOVE_CHAT_MESSAGE',
      }),
      send(message) {

        this.sendMessage({
          targetId: this.targetId,
          ...message,
        });
      },
      remove(message) {

        this.removeMessage({
          targetId: this.targetId,
          ...message,
        });
      },
    },
    beforeMount() {

      this.$socket.emit('join', {
        targetId: this.targetId,
      });
    },
    mounted() {

      // Force to scroll down.

      setTimeout(() => {

        const list = document
          .querySelector('.sc-message-list');

        if (list)
          list.scrollTop = list.scrollHeight;

      }, 1000);
    },
    beforeDestroy() {

      this.$socket.emit('leave', {
        targetId: this.targetId,
      });
    },
  };

</script>

<style lang="scss">

  .group-chat {
    height: 100%;
    position: relative;

    & > * {
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      color: inherit;
      position: absolute;
    }

    .sc-header {
      display: none;
    }

    .sc-launcher {
      display: none;
    }

    .sc-message-list {
      height: 100%;
      border-top-left-radius: .4rem;
      border-top-right-radius: .4rem;
    }

    .sc-chat-window {
      height: 100%;
      position: static;
    }
  }

</style>
